<template>
    <div>
        <loading :active.sync="loading.app" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position" :icon="toast.icon"></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a href="Javascript:;" class="headerButton" @click="$router.go(-1)">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Verifikasi Data Diri</div>
        </div>
        <!-- * App Header -->
        <!-- App Capsule -->
        <div id="appCapsule" class="pb-2" v-if="loading.app == false">
            <div v-if="status_verification == null">
                <div class="section inset mt-2">
                    <!-- <div class="wide-block pt-2 pb-2"> -->
                        <!-- <div class="mb-1 text-center">Masukkan data dengan benar, segala tindakan pemalsuan data akan diproses secara hukum sesuai aturan yang berlaku.</div>
                        <p class="text-danger" v-if="customer.account_verified_status == 'REJECTED'">Data diri yang dikirim sebelumnya di tolak, mohon pastikan data yang anda kirim merupakan data diri anda sendiri dan pastikan foto data diri terlihat jelas dan sudah sesuai kriteria yang di minta.</p> -->
                        <form>
                            <h3 style="font-weight:bold;">Lengkapi Data Diri</h3>
                            <p class="text-justify" style="font-size:11px;line-height: 15px;"><b>PENTING!</b> Pastikan data diri yang Kamu masukkan sudah benar karena data tersebut akan di validasi di sistem pemerintahan untuk memastikan kebenarannya</p>
                            <hr style="margin-top:5px;">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="label">Nama Lengkap</label>
                                    <input type="text" class="form-control text-uppercase" v-model="detail_customer.full_name" style="font-size:13px;">
                                </div>
                            </div>
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="label">Tempat Lahir</label>
                                    <input type="text" class="form-control text-uppercase" v-model="detail_customer.birthplace" style="font-size:13px;">
                                </div>
                            </div>
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="label">Tanggal Lahir</label>
                                    <div class="row">
                                        <div class="col-4">
                                            <input type="number" class="form-control" v-model="detail_customer.birthdate" placeholder="Tanggal" style="font-size:13px;">
                                        </div>
                                        <div class="col-4">
                                            <select name="" class="form-control" v-model="detail_customer.birthmonth" style="font-size:13px;padding:0px 15px 0px 10px;">
                                                <option value="" disabled selected>- Bulan -</option>
                                                <option value="01">Januari</option>
                                                <option value="02">Februari</option>
                                                <option value="03">Maret</option>
                                                <option value="04">April</option>
                                                <option value="05">Mei</option>
                                                <option value="06">Juni</option>
                                                <option value="07">Juli</option>
                                                <option value="08">Agustus</option>
                                                <option value="09">September</option>
                                                <option value="10">Oktober</option>
                                                <option value="11">November</option>
                                                <option value="12">Desember</option>
                                            </select>
                                        </div>
                                        <div class="col-4">
                                            <input type="number" class="form-control" v-model="detail_customer.birthyear" placeholder="Tahun" style="font-size:13px;">
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>

                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="label">Jenis Kelamin</label>
                                    <select name="" class="form-control" v-model="detail_customer.gender" style="font-size:13px;padding:0px 15px 0px 10px;">
                                        <option value="" disabled selectd>- Pilih -</option>
                                        <option value="L">Laki-Laki</option>
                                        <option value="P">Perempuan</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="label">Alamat (Domisili saat ini)</label>
                                    <textarea class="form-control text-capitalize" v-model="detail_customer.address" placeholder="Alamat lengkap (Nama Jalan, Block, No, RT dan RW)" style="font-size:13px;"></textarea>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group boxed">
                                        <div class="input-wrapper">
                                            <label class="label">Provinsi</label>
                                            <select name="" class="form-control" v-model="detail_customer.provinces_id" style="font-size:13px;padding:0px 15px 0px 10px;" @change="changeProvinces($event)">
                                                <option value="" disabled selectd>- Pilih -</option>
                                                <option v-for="item in provinces" :value="item.id" :key="item.id" :data-name="item.name">{{item.name}}</option>
                                            </select>
                                            <input type="hidden" class="form-control" v-model="detail_customer.provinces_name" style="font-size:13px;">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group boxed">
                                        <div class="input-wrapper">
                                            <label class="label">Kabupaten/Kota</label>
                                            <select name="" class="form-control" v-model="detail_customer.regencies_id" style="font-size:13px;padding:0px 15px 0px 10px;" @change="changeRegencies($event)">
                                                <option value="" disabled selectd>- Pilih -</option>
                                                <option v-for="item in regencies" :value="item.id" :key="item.id" :data-name="item.name">{{item.name}}</option>
                                            </select>
                                            <input type="hidden" class="form-control" v-model="detail_customer.regencies_name" style="font-size:13px;">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group boxed">
                                        <div class="input-wrapper">
                                            <label class="label">Kecamatan</label>
                                            <select name="" class="form-control" v-model="detail_customer.districts_id" style="font-size:13px;padding:0px 15px 0px 10px;" @change="changeDistricts($event)">
                                                <option value="" disabled selectd>- Pilih -</option>
                                                <option v-for="item in districts" :value="item.id" :key="item.id" :data-name="item.name">{{item.name}}</option>
                                            </select>
                                            <input type="hidden" class="form-control" v-model="detail_customer.districts_name" style="font-size:13px;">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group boxed">
                                        <div class="input-wrapper">
                                            <label class="label">Kelurahan</label>
                                            <select name="" class="form-control" v-model="detail_customer.villages_id" style="font-size:13px;padding:0px 15px 0px 10px;" @change="changeVillages($event)">
                                                <option value="" disabled selectd>- Pilih -</option>
                                                <option v-for="item in villages" :value="item.id" :key="item.id" :data-name="item.name">{{item.name}}</option>
                                            </select>
                                            <input type="hidden" class="form-control" v-model="detail_customer.villages_name" style="font-size:13px;">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    <!-- </div> -->
                </div>
                <div class="section inset mt-1">
                    <!-- <div class="wide-block pt-2 pb-2"> -->
                        <button class="btn btn-primary btn-block btn-lg" @click="showConfirmation('show')">Simpan & Lanjutkan</button>
                    <!-- </div> -->
                </div>
            </div>
            <div v-else-if="status_verification == 'WAITING'">
                <div class="section inset text-center">
                    <img :src="require('@/assets/verification_waiting.png')" alt="Verifikasi dalam proses" class="w-50 mb-3" style="margin-top:50px;"><br>
                    <h3>Dalam Proses Verifikasi</h3>
                        <p style="font-size: 12px;line-height: 150%;">Waktu proses verifikasi data diri maksimal 1x24 jam (tidak termasuk hari sabtu, minggu dan hari libur nasional)</p>
                    <!-- <div class="wide-block pt-2 pb-2 text-center">
                        <ion-icon name="sync-outline" style="font-size: 80px;color:#FF8C00;"></ion-icon>
                        <h2>Dalam Proses Verifikasi</h2>
                        <p>Proses verifikasi data diri maksimal 1x24 jam (tidak termasuk sabtu, minggu dan hari libur nasional)</p>
                    </div> -->
                </div>
            </div>
            <div v-else-if="status_verification == 'VERIFIED'">
                <div class="section inset text-center">
                    <img :src="require('@/assets/verification_success.png')" alt="Verifikasi dalam proses" class="w-50 mb-3" style="margin-top:50px;"><br>
                    <h3>Verifikasi Berhasil!</h3>
                    <p style="font-size: 12px;line-height: 150%;margin-bottom: 5px;">Selamat data diri Kamu sudah berhasil terverifikasi.</p>
                </div>
                <!-- <div class="section inset mt-2">
                    <div class="wide-block pt-2 pb-2 text-center">
                        <ion-icon name="checkmark-circle" style="font-size: 80px;color:#00a65a;"></ion-icon>
                        <h2>Berhasil diverifikasi</h2>
                        <p>Selamat data diri anda telah berhasil diverifikasi.</p>
                    </div>
                </div> -->
            </div>
            <div v-else-if="status_verification == 'REJECTED'">
                <div class="section inset text-center">
                    <img :src="require('@/assets/verification_rejected.png')" alt="Verifikasi dalam proses" class="w-50 mb-3" style="margin-top:50px;"><br>
                    <h3>Verifikasi ditolak</h3>
                    <p style="font-size: 12px;line-height: 150%;margin-bottom: 5px;">Permintaan verifikasi data diri kamu belum dapat diterima dengan alasan sebagai berikut : </p>
                    <p class="text-danger" style="font-size: 14px;line-height: 150%;"><b><i>{{ note_reject_verification }}</i></b></p>
                    <button class="btn btn-outline-primary btn-lg" style="height:40px;border-width:1px;" @click="status_verification = null">Verifikasi Ulang</button>
                </div>
            </div>
        </div>

        <action-sheet ref="modalConfirmation" :title="'Kebijakan Privasi'" :header="true" :inset="false" :content-height="false"> 
            
            <privacy-policy></privacy-policy>
            <hr>
            <div class="text-center" style="font-size: 12px;line-height: 150%;">
                <p>Dengan memilih tombol "<b>Ya, Setuju</b>" Anda telah menyetujui <b>Kebijakan Privacy</b> dan <b>Ketentuan Layanan</b> ini</p>
            </div>
            <div class="form-group basic pb-0">
                <div class="row">
                    <div class="col-6">
                        <button class="btn btn-outline-primary btn-block btn-lg" style="height:40px;border-width:1px;" @click="showConfirmation('hide')">Tidak</button>
                    </div>
                    <div class="col-6">
                        <ButtonLoader :loading="buttonLoadingModalConfirm" :styled="'btn btn-primary btn-block btn-lg'" style="height:40px;" @click.native="submit()">Ya, Setuju</ButtonLoader>
                    </div>
                </div>
            </div>
        </action-sheet>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import $axios from './../../api.js'
export default {
    name: 'account.data-diri',
    data() {
        return {
            dialogLoading: false,
            buttonLoadingModalConfirm: false,
            status_verification: null,
            note_reject_verification: 'Data yang dikirimkan belum sesuai ketentuan',
            detail_customer:{
                full_name: '',
                birthplace: '',
                birthdate: '',
                birthmonth: '',
                birthyear: '',
                gender: '',
                address: '',
                provinces_id: '',
                provinces_name: '',
                regencies_id: '',
                regencies_name: '',
                districts_id: '',
                districts_name: '',
                villages_id: '',
                villages_name: '',
            },
            
        }
    },
    created() {
        this.$store.commit('SET_LOADING', {app:true})
        this.getProvinces()
        this.getCustomer().then((response) => {
            if(response.data.account_detail != null){
                if(response.data.account_verified_status == 'APPROVED'){
                    this.status_verification = 'VERIFIED'
                }else if(response.data.account_verified_status == 'PROCESS'){
                    this.status_verification = 'WAITING'
                }else if(response.data.account_verified_status == 'REJECTED'){
                    this.status_verification = 'REJECTED'
                    this.note_reject_verification = response.data.account_verified_note
                }
                
                this.detail_customer.full_name = response.data.account_detail.full_name
                this.detail_customer.birthplace = response.data.account_detail.birthplace
                this.detail_customer.gender = response.data.account_detail.gender
                let birthdate = response.data.account_detail.birthdate
                this.detail_customer.birthdate = birthdate.split('-')[2]
                this.detail_customer.birthmonth = birthdate.split('-')[1]
                this.detail_customer.birthyear = birthdate.split('-')[0]
                this.detail_customer.address = response.data.account_detail.address
                this.detail_customer.provinces_id = response.data.account_detail.provinces_id
                this.detail_customer.provinces_name = response.data.account_detail.provinces_name
                this.detail_customer.regencies_id = response.data.account_detail.regencies_id
                this.detail_customer.regencies_name = response.data.account_detail.regencies_name
                this.detail_customer.districts_id = response.data.account_detail.districts_id
                this.detail_customer.districts_name = response.data.account_detail.districts_name
                this.detail_customer.villages_id = response.data.account_detail.villages_id
                this.detail_customer.villages_name = response.data.account_detail.villages_name
                if(this.detail_customer.provinces_id != ""){
                    this.getRegencies(this.detail_customer.provinces_id).then(() => {
                        this.getDistricts(this.detail_customer.regencies_id).then(() => {
                            this.getVillages(this.detail_customer.districts_id)
                        })
                    })
                }
            }
        })
        this.getProvinces()
    },
    computed: {
        ...mapState(['customer','loading','toast','provinces','regencies','districts','villages'])
    },
    methods: {
        ...mapActions(['getCustomer','getProvinces','getRegencies','getDistricts','getVillages']),
        ...mapMutations(['RESET_PROVINCES','RESET_REGENCIES','RESET_DISTRICTS','RESET_VILLAGES']),
        showConfirmation(value){
            let element = this.$refs.modalConfirmation.$el
            window.$(element).modal(value)
        },
        submit(){
            this.$store.commit('RESET_TOAST')
            this.buttonLoadingModalConfirm = true
            $axios.post('/update-data-diri', this.detail_customer)
            .then((response) => {
                this.showConfirmation('hide')
                this.buttonLoadingModalConfirm = false
                this.$store.commit('SET_CUSTOMER', response.data.data)
                if(response.data.data.account_verified_status == 'APPROVED'){
                    this.status_verification = 'VERIFIED'
                }else if(response.data.data.account_verified_status == 'PROCESS'){
                    this.status_verification = 'WAITING'
                }else{
                    if(response.data.data.account_verified_status == 'REJECTED'){
                        this.status_verification = 'REJECTED'
                    }
                    
                    this.status_verification = null
                    if (typeof window.AndroidNative !== 'undefined') {
                        window.AndroidNative.showFormVerification();
                        this.$router.push({name:'forward'});
                    } else {
                        this.$store.commit('SET_TOAST', {show:true,message:'Verifikasi selanjutnya hanya dapat dilakukan melalui Aplikasi Mobile',tipe:'default',icon:'warning'})
                    }
                }
            }).catch((error) => {
                console.log(error.response)
                if(error.response.status == 400){
                    this.$store.commit('SET_TOAST', {show:true,message:error.response.data.message,tipe:'default',icon:'danger'})
                }else{
                    this.$store.commit('SET_TOAST', {show:true,message:'Pastikan semua data yang diminta sudah diisi dengan benar',tipe:'default',icon:'danger'})
                }
                this.showConfirmation('hide')
                this.buttonLoadingModalConfirm = false
            })
        },
        changeProvinces(event){
            this.detail_customer.provinces_name = event.target.options[event.target.options.selectedIndex].getAttribute('data-name')
            this.detail_customer.regencies_id = ''
            this.detail_customer.regencies_name = ''
            this.detail_customer.districts_id = ''
            this.detail_customer.districts_name = ''
            this.detail_customer.villages_id = ''
            this.detail_customer.villages_name = ''
            this.RESET_REGENCIES()
            this.RESET_DISTRICTS()
            this.RESET_VILLAGES()
            this.getRegencies(this.detail_customer.provinces_id)
        },
        changeRegencies(event){
            this.detail_customer.regencies_name = event.target.options[event.target.options.selectedIndex].getAttribute('data-name')
            this.detail_customer.districts_id = ''
            this.detail_customer.districts_name = ''
            this.detail_customer.villages_id = ''
            this.detail_customer.villages_name = ''
            this.RESET_DISTRICTS()
            this.RESET_VILLAGES()
            this.getDistricts(this.detail_customer.regencies_id)
        },
        changeDistricts(event){
            this.detail_customer.districts_name = event.target.options[event.target.options.selectedIndex].getAttribute('data-name')
            this.detail_customer.villages_id = ''
            this.detail_customer.villages_name = ''
            this.RESET_VILLAGES()
            this.getVillages(this.detail_customer.districts_id)
        },
        changeVillages(event){
            this.detail_customer.villages_name = event.target.options[event.target.options.selectedIndex].getAttribute('data-name')
        }
    },
    destroyed() {
        this.$store.commit('RESET_LOADING')
        this.$store.commit('RESET_TOAST')
        this.RESET_PROVINCES()
        this.RESET_REGENCIES()
        this.RESET_DISTRICTS()
        this.RESET_VILLAGES()
    },
}
</script>